export const alertsData=[
  {
    id:1,
    title:'Banned Notification',
    description:'Here I should be able to see if the user took a screenshot or tried to bypass any of our protection and all the user’s suspicious activities or if a subscribed user tried to log in from multiple devices and his login state (true or false) also log the user’s IP and device Name + ID',
  },
]
